var map = {
	"./attach_file.svg": "a951",
	"./attach_money.svg": "0aab",
	"./border_all.svg": "66cc",
	"./border_bottom.svg": "5850",
	"./border_clear.svg": "c119",
	"./border_color.svg": "19ec",
	"./border_horizontal.svg": "441d",
	"./border_inner.svg": "35b7",
	"./border_left.svg": "fe76",
	"./border_outer.svg": "5645",
	"./border_right.svg": "7a82",
	"./border_style.svg": "1197",
	"./border_top.svg": "3eb3",
	"./border_vertical.svg": "ffa8",
	"./bubble_chart.svg": "fbae",
	"./drag_handle.svg": "af15",
	"./format_align_center.svg": "7e7f",
	"./format_align_justify.svg": "3587",
	"./format_align_left.svg": "7b01",
	"./format_align_right.svg": "5b02",
	"./format_bold.svg": "955d",
	"./format_clear.svg": "e238",
	"./format_color_fill.svg": "5e98",
	"./format_color_reset.svg": "eb13",
	"./format_color_text.svg": "415f",
	"./format_indent_decrease.svg": "2487",
	"./format_indent_increase.svg": "84f23",
	"./format_italic.svg": "8e66",
	"./format_line_spacing.svg": "a785",
	"./format_list_bulleted.svg": "e95a",
	"./format_list_numbered.svg": "e18b",
	"./format_paint.svg": "e9d6",
	"./format_quote.svg": "a13a",
	"./format_shapes.svg": "5325",
	"./format_size.svg": "e51b",
	"./format_strikethrough.svg": "3d06",
	"./format_textdirection_l_to_r.svg": "bc44",
	"./format_textdirection_r_to_l.svg": "6304",
	"./format_underlined.svg": "58ec",
	"./functions.svg": "2caa",
	"./highlight.svg": "8480",
	"./insert_chart.svg": "9601",
	"./insert_comment.svg": "57e8",
	"./insert_drive_file.svg": "26f8",
	"./insert_emoticon.svg": "f6fc",
	"./insert_invitation.svg": "ee63",
	"./insert_link.svg": "97a5",
	"./insert_photo.svg": "512f",
	"./linear_scale.svg": "7fe4",
	"./merge_type.svg": "fab8",
	"./mode_comment.svg": "8cb8",
	"./mode_edit.svg": "2166",
	"./monetization_on.svg": "bcfe",
	"./money_off.svg": "5502",
	"./multiline_chart.svg": "a248",
	"./pie_chart.svg": "acea",
	"./pie_chart_outlined.svg": "f1f3",
	"./publish.svg": "e026",
	"./short_text.svg": "159d",
	"./show_chart.svg": "38db",
	"./space_bar.svg": "66e6",
	"./strikethrough_s.svg": "cf83",
	"./text_fields.svg": "396e",
	"./title.svg": "d8ea",
	"./vertical_align_bottom.svg": "8b5a",
	"./vertical_align_center.svg": "beae",
	"./vertical_align_top.svg": "cfd8",
	"./wrap_text.svg": "30d3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "21c0";